import React, { useState, useRef, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
// import Stack from "react-bootstrap/Stack";
import { colors, resolveColor } from "utils/styles";
import ButtonGroup from "./ButtonGroup";
import Title from "./Title";
import Content from "./Content";
import GeneralRichText from "./Content";
import OpenCloseBtn from "./OpenCloseBtn";
import { sizeEqualOrLessThan } from "utils/helpers";

export default function CheckList(props) {
	const fields = props.data?.fields;
	const checklistTitle = fields?.checklistTitle;
	const checklistItems = fields?.checklistItems || [];
	const backgroundColor = fields?.backgroundColor;
	const paddingBottom = fields?.paddingBottom !== undefined ? fields?.paddingBottom : 2;
	const paddingTop = fields?.paddingTop !== undefined ? fields?.paddingTop : 2;
	const columnWidth = fields?.columnWidth !== undefined ? fields?.columnWidth : 12;
	const hashId = fields?.hashId;
	return (
		<div id={hashId} className="w-100 px-4 ChecklistComponent">
			<Container fluid className="g-0 pb-lg-3">
				<Container className="container-lg">
					{checklistTitle && <Title title={checklistTitle} />}
					<Row className="g-0">
						{/* Document */}
						<Col xs="12" md={columnWidth}>
							{checklistItems.map((item, index) => {
								return <ChecklistItem key={item.sys.id} item={item} />;
							})}
						</Col>
					</Row>
					{props.data?.fields?.buttons && (
						<Row className="py-4 g-0">
							<Col className="justify-content-center d-flex">
								<ButtonGroup buttonGroupData={props.data?.fields?.buttons} />
							</Col>
						</Row>
					)}
				</Container>
			</Container>
			<style jsx="true">{`
				.ChecklistComponent {
					background: ${resolveColor(backgroundColor)};
					padding-top: ${paddingTop}em;
					padding-bottom: ${paddingBottom}em;
				}
			`}</style>
		</div>
	);
}

const ChecklistItem = ({ item }) => {
	const mdOrSmaller = sizeEqualOrLessThan("md");
	const itemRef = useRef();
	const yOffset = -130;

	const executeScroll = () => {
		const el = itemRef.current;
		const observer = new window.IntersectionObserver(
			([entry]) => {
				observer.unobserve(el);
				if (entry.isIntersecting) {
					return;
				}
				const y = itemRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
				window.scrollTo({ top: y, behavior: "instant" });
			},
			{
				root: null,
				threshold: 1, // set offset 0.1 means trigger if atleast 10% of element in viewport
			}
		);

		observer.observe(el);
	};

	const { content, title } = item.fields;
	const [isOpen, setIsOpen] = useState(false);
	const toggleDoc = (e) => {
		e.nativeEvent.stopImmediatePropagation();
		setIsOpen((isOpen) => !isOpen);
	};

	// Memoize the title component to prevent unnecessary re-renders
	const memoizedTitle = useMemo(() => (
		<Title fontSize={mdOrSmaller ? "25px" : "30px"} className="m-0" title={item.fields?.title} />
	), [item.fields?.title, mdOrSmaller]);

	return (
		<div ref={itemRef} className="listItem ps-1 ps-md-5 m-1 radius-5px">
			<Row className=" align-items-center p-2  g-0">
				<Col onClick={toggleDoc} className="clickable" xs={11}>
					<Row className="py-4 g-0">
						<Col className="clickable align-items-center d-flex " xs={1}>
							<OpenCloseBtn listId={item.listId} isOpen={isOpen} />
						</Col>
						<Col className="d-flex justify-content-center" xs={11}>
							{memoizedTitle}
						</Col>
					</Row>
				</Col>

				<Col lg={{ offset: 1, span: 9 }}>
					<div className="relative documentChecklist">
						<hr />
						{content.fields.generalRichText && <GeneralRichText content={content} />}

						{!content.fields.generalRichText && <Content content={content} />}

						<div className="clickable align-items-center d-flex extra-close" xs={1}>
							<OpenCloseBtn
								onClick={(e) => {
									toggleDoc(e);
									executeScroll();
								}}
								listId={item.listId}
								isOpen={isOpen}
							/>
						</div>
					</div>
				</Col>
			</Row>

			<style jsx="true">{`
				.extra-close {
					position: absolute;
					right: 1em;
					bottom: 1em;
					transform: rotate(-180deg);
					transition: opacity 0.3s ease;
					opacity: ${isOpen ? 1 : 0};
				}
				.listItem {
					background: ${colors.white};
					box-shadow: 2px 2px 10px #0000002e;
					transition: box-shadow 0.3s;
				}
				.listItem:hover {
					box-shadow: 2px 2px 10px ${colors["greyBlue"]};
				}
				.documentChecklist {
					max-height: ${isOpen ? "12000px" : "0px"};
					overflow: hidden;
					 {
						/* transition: all 0.3s linear; */
					}
					padding-bottom: ${isOpen ? "3em" : "0em"};
				}
			`}</style>
		</div>
	);
};
